// DS: i5.8
import React from 'react';
import IconWrap from '../../IconWrap';
const Unlock = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 3c.98 0 2.12.531 3.418 1.594a.719.719 0 01-.096 1.178l-.26.15a1 1 0 01-1.116-.08c-.675-.528-1.265-.808-1.77-.837L12 5a3 3 0 00-2.995 2.824L9 8v3h10a1 1 0 011 1v8a1 1 0 01-1 1H5a1 1 0 01-1-1v-8a1 1 0 011-1h2V8a5 5 0 015-5zm6 10H6v6h12v-6zm-6 1a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z"
    })));
Unlock.displayName = 'Unlock';
export default Unlock;

//# sourceMappingURL=Unlock.js.map